import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationTituloReceber } from './integration-titulo-receber';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeAnual, isPeriodicidadeAnual, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationTituloReceberHttpService } from './services';

@Component({
    selector: 'sgt-integration-titulo-receber-modal',
    templateUrl: './integration-titulo-receber-modal.component.html',
    styleUrls: ['./integration-titulo-receber-modal.component.less']
})
export class IntegrationTituloReceberModalComponent implements OnInit {
    entity = new IntegrationTituloReceber();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeAnual,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationTituloReceberHttpService: IntegrationTituloReceberHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationTituloReceberPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataInicialBase = null;
        }
    }

    /** Executa as integrações de leitura dos títulos com os sistemas ERP's manualmente */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando títulos com o ERP', 'Executando sincronização dos títulos com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationTituloReceberHttpService.execReadIntegrationManual(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização dos títulos com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização dos títulos com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização dos títulos com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Títulos emitidos nas últimas 24 horas';
        } else if (isPeriodicidadeAnual(periodicidade)) {
            return 'Anual - Títulos emitidos a partir do ano anterior';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Títulos emitidos a partir de uma data específica'
        }
        return '';
    }
}
